import Vue from 'vue'
import Vuex from 'vuex'
import pathify from './pathify'
import { make } from 'vuex-pathify'
const staticState = {
  loading2: null,
  alertBox: null,
  docNo: null,
  listCCG: [],
  listAAG: [],
  listTTG: [],
  listDayG: [{ text: '', value: '00' }],
  listYearG: [],
  listMonthGAll: [
    { text: '', value: '00' },
    { text: 'มกราคม', value: '01' },
    { text: 'กุมภาพันธ์', value: '02' },
    { text: 'มีนาคม', value: '03' },
    { text: 'เมษายน', value: '04' },
    { text: 'พฤษภาคม', value: '05' },
    { text: 'มิถุนายน', value: '06' },
    { text: 'กรกฎาคม', value: '07' },
    { text: 'สิงหาคม', value: '08' },
    { text: 'กันยายน', value: '09' },
    { text: 'ตุลาคม', value: '10' },
    { text: 'พฤศจิกายน', value: '11' },
    { text: 'ธันวาคม', value: '12' }
  ],
  rcossYM: '6712',
  monkGet: 2,

}

const getDefaultState = () => ({
  DDOPA: {
    token: "",
    pid: 0,
    fname: "",
    lname: "",
    lnameWrite: ""
  }

})

// initial state
const state = Object.assign(staticState, getDefaultState())

const mutations = make.mutations(state)
const resetMutation = {
  resetState() {
    Object.assign(state, getDefaultState())
  },
}
Object.assign(mutations, resetMutation)
const actions = make.actions(state)
const getters = make.getters(state)


// use store
Vue.use(Vuex)

// create store
export default new Vuex.Store({
  modules: {
  },
  // use the plugin
  plugins: [
    pathify.plugin
  ],
  // store properties
  state,
  mutations,
  actions,
  getters
})
